import { memo, useCallback, useMemo } from 'react';

import { Button, ButtonProps } from '@desygner/ui-common-components';

import { FloatingToolbarClick } from '../FloatingToolbar';
import { FloatingToolbarItem } from '../FloatingToolbar.type';

export interface FloatingToolbarButtonProps {
  item: FloatingToolbarItem;
  toolbarRef?: React.RefObject<HTMLDivElement>;
  onClick?: (event: FloatingToolbarClick) => void;
}

export const FloatingToolbarButton = memo(function FloatingToolbarButton({
  item,
  onClick,
  toolbarRef,
}: FloatingToolbarButtonProps): React.ReactElement {
  const handleClick = useCallback(() => {
    onClick?.({
      action: item.action,
      payload: {
        ...item,
        bbox: toolbarRef?.current?.getBoundingClientRect(),
      },
    });
  }, [item, onClick, toolbarRef]);

  const icon = useMemo(() => {
    if (!item.icon) return undefined;

    return {
      name: item.icon.name,
      color: item.icon.color,
      size: 'Small',
    } as ButtonProps['icon'];
  }, [item.icon]);

  return (
    <Button
      onClick={handleClick}
      label={item.label}
      title={item.tooltip}
      active={!!item.data?.active}
      icon={icon}
      size="Small"
      variant="ghost"
    />
  );
});
